import { blockOptions } from './constants'

export const isTotalBlock = config => blockOptions.every(option => config[option.value])

export const getBlockOptionChanges = (config, option, checked) => {
  const changes = { [option]: checked }

  if (!isTotalBlock({ ...config, ...changes })) return changes

  return { ...changes, custom_message_type: null }
}
